import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getRemovablePreferenceDefaults } from "../removablePreferenceForm";

const SPLINT_TYPES = ["Bruxisme", "Blanchiment", "Contention"];
const THICKNESSES = ["1 mm", "1,5 mm", "2 mm", "3 mm"];
const HARDNESSES = ["Dure", "Semi-rigide", "Souple"];
const COVERAGES = ["Total", "Partiel"];

export const SplintPreferences = withForm({
  defaultValues: getRemovablePreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "splintType",
      "splintThickness",
      "splintHardness",
      "splintCoverage",
    ]);

    return (
      <SaveableCard
        title="Gouttières"
        description="Réglages du type le plus commandé"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Type le plus commandé</Text>
              <form.Field name="splintType">
                {field => (
                  <Select
                    data={SPLINT_TYPES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Épaisseur</Text>
              <form.Field name="splintThickness">
                {field => (
                  <Select
                    data={THICKNESSES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Dureté du bruxisme</Text>
            <form.Field name="splintHardness">
              {field => (
                <Group>
                  {HARDNESSES.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Recouvrement</Text>
            <form.Field name="splintCoverage">
              {field => (
                <Group>
                  {COVERAGES.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
